import Icon from "./Icon";
import { navigation, siteDetails } from "../siteContent";

const Footer = () => (
  <footer className="site-footer">
    <div className="container footer-grid">
      <div className="footer-about">
        <a aria-label="Ascot Lodge, back to home" className="brand brand--footer" href="#home">
          <span aria-hidden="true" className="brand__mark">AL</span>
          <span className="brand__text">
            <strong>Ascot Lodge</strong>
            <small>Nursing Home</small>
          </span>
        </a>
        <p>
          Nursing and personal care for older people in a warm, familiar
          Southport home.
        </p>
        <a
          className="footer-cqc"
          href={siteDetails.cqcUrl}
          rel="noreferrer"
          target="_blank"
        >
          CQC rated Good
          <Icon name="external" size={16} />
        </a>
      </div>

      <div>
        <h2>Explore</h2>
        <ul className="footer-links">
          {navigation.map(({ label, href }) => (
            <li key={href}>
              <a href={href}>{label}</a>
            </li>
          ))}
          <li><a href="#careers">Careers</a></li>
        </ul>
      </div>

      <div>
        <h2>Contact</h2>
        <address className="footer-contact">
          <a href={siteDetails.phoneHref}>
            <Icon name="phone" size={18} />
            {siteDetails.phoneDisplay}
          </a>
          <a href={`mailto:${siteDetails.email}`}>
            <Icon name="mail" size={18} />
            {siteDetails.email}
          </a>
          <a href={siteDetails.mapsUrl} rel="noreferrer" target="_blank">
            <Icon name="location" size={18} />
            <span>{siteDetails.addressLines.map((line) => <span key={line}>{line}</span>)}</span>
          </a>
        </address>
      </div>
    </div>

    <div className="footer-bottom">
      <div className="container footer-bottom__inner">
        <p>© {new Date().getFullYear()} Ascot Lodge Ltd. All rights reserved.</p>
        <p>Website information should be confirmed directly with the home.</p>
        {/* TODO(content): Add links when approved privacy and cookie policies are supplied. */}
      </div>
    </div>
  </footer>
);

export default Footer;
